import { render, staticRenderFns } from "./reading-comprehension.vue?vue&type=template&id=364a36dd&"
import script from "./reading-comprehension.vue?vue&type=script&lang=js&"
export * from "./reading-comprehension.vue?vue&type=script&lang=js&"
import style0 from "./reading-comprehension.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports